import { ApiMethodTypes, RequestObjectI } from 'src/api/request-objects';

export const API_AGGREGATOR_GET_DISCLOSURES: RequestObjectI = {
  url: 'aggregator/iframe/disclosures',
  method: ApiMethodTypes.GET,
};

export const API_AGGREGATOR_GET_STATUS: RequestObjectI = {
  url: 'aggregator/iframe/status',
  method: ApiMethodTypes.GET,
};

export const API_AGGREGATOR_ACCEPT_DISCLOSURES: RequestObjectI = {
  url: 'aggregator/iframe/disclosures/accept',
  method: ApiMethodTypes.POST,
};
